import React, { useContext, Fragment } from 'react'
import ResourceTypeContext from '../../context/ResourceTypeContext/ResourceTypeContext';
import EntryAndDepartureReportContext from '../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import { CustomTabletFilter } from '../CustomTabletFilter/CustomTabletFilter';
import { t } from 'i18next';
import AccessOpeningContext from '../../context/AccessOpeningContext/AccessOpeningContext';
import ContractorsContext from '../../context/ContractorsContext/ContractorsContext';
import { getDataUserByKey, getTenantInfoByKey, getUserBuilding, getUserOpening } from '../../helpers/helpers';
import AccessBuildingContext from '../../context/AccessBuildingContext/AccessBuildingContext';
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext';

export const EntryAndDepartureTabletFilter = () => {

    const profile_id = getDataUserByKey('access_profile_id');
    const isGuard = Number(profile_id) === 3;

    const haveSelectedAnAccessOpening = getUserOpening().descripcion !== t('NO_OPENING');
    const haveSelectedAnAccessBuilding = getUserBuilding().buildingDescription !== t('NO_BUILDING');

    const userOpening = getUserOpening();
    const userBuilding = getUserBuilding();

    const { entryAndDepartureReportState, getEntriesAndDepartures } = useContext(EntryAndDepartureReportContext);
    const { filters } = entryAndDepartureReportState;
    const { permanence_time_from, permanence_time_to } = filters;

    const { resourceState } = useContext(ResourceTypeContext);
    const { resourcesTypes } = resourceState;

    const { accessOpeningState } = useContext(AccessOpeningContext);
    const { accessOpenigs } = accessOpeningState;

    const { contractorsState } = useContext(ContractorsContext);
    const { contractors } = contractorsState;

    const { accessBuildingState } = useContext(AccessBuildingContext);
    const { accessBuildings } = accessBuildingState;

    const { accessAreaState } = useContext(AccessAreaContext);
    const { accessAreas } = accessAreaState;
    const accessAreasOptions = [{
        area_id: null,
        code: "",
        description: t('FREE_ACCESS_AREA')
    }].concat(accessAreas);


    const contractorsFilterFc = () => {
        let contractorsValues = [];
        contractors.forEach((element, i) => {
            if (filters.contractors.includes(element.contractor_id)) {
                contractorsValues.push(element);
            }
        });
        return contractorsValues;
    }
    const contractorsTablets = contractorsFilterFc();

    const openingsFilterFc = () => {
        let openingsValues = [];
        accessOpenigs.forEach((element, i) => {
            if (filters.opening_code.includes(element.codigo)) {
                openingsValues.push(element);
            }
        });
        return openingsValues;
    }
    const openingsTablets = openingsFilterFc();

    const resourceTypesFilterFc = () => {
        let resTypesValues = [];
        resourcesTypes.forEach((element, i) => {
            if (filters.resource_type.includes(element.code)) {
                resTypesValues.push(element);
            }
        });
        return resTypesValues;
    }
    const resTypesTablets = resourceTypesFilterFc();

    const accessBuildingTablets = accessBuildings.filter(accessBuilding => filters.buildings.some(building => building === accessBuilding.buildingId));

    const accessAreasTablets = accessAreasOptions.filter(accessArea => filters.areas.some(area => area === accessArea.area_id));

    const deleteFilter = (filterName, isMulti = false, deleteValue, value = '') => {
        if (isMulti) {
            return getEntriesAndDepartures({
                ...filters,
                [filterName]: filters[filterName].filter((el) => el !== deleteValue)
            })
        }

        return getEntriesAndDepartures({
            ...filters,
            [filterName]: value
        })
    };

    const handleDeleteOpeningTablet = (openingCode) => {
        const newBuildingsFilter = accessBuildings.filter(accessBuilding => filters.buildings.some(building => building === accessBuilding.buildingId && accessBuilding.opening.openingCode !== openingCode)).map(filter => filter.buildingId);
        const newAreasFilter = accessAreasOptions.filter(area => newBuildingsFilter.some(newBuildingFilter => area.area_id !== null && (area.Building.buildingId === newBuildingFilter))).map(filter => filter.area_id);
        const newData = {
            ...filters,
            opening_code: filters.opening_code.filter((el) => el !== openingCode),
            buildings: newBuildingsFilter,
            areas: newAreasFilter
        }
        getEntriesAndDepartures(newData)
    }

    const handleDeleteBuildingTablet = (buildingId) => {
        const newBuildingsFilter = filters.buildings.filter((el) => el !== buildingId)
        const newAreasFilter = accessAreasOptions.filter(area => newBuildingsFilter.some(newBuildingFilter => area.area_id !== null && (area.Building.buildingId === newBuildingFilter))).map(filter => filter.area_id);
        const newData = {
            ...filters,
            buildings: newBuildingsFilter,
            areas: newAreasFilter
        }
        getEntriesAndDepartures(newData)
    }

    return (
        <div className='d-flex mt-3 gap-2' style={{ overflowX: 'auto' }}>

            {
                resTypesTablets.length > 0 ?
                    resTypesTablets.map((el, i) => {
                        return (
                            <Fragment key={i}>
                                <CustomTabletFilter
                                    withTooltip={true}
                                    placementTooltip={'top'}
                                    textTooltip={t('RESS')}
                                    idTargetTooltip={`resTypesFilterTooltip${i}`}
                                    filterName={el.description}
                                    deleteFilterFunction={() => deleteFilter('resource_type', true, el.code)}
                                />
                            </Fragment>
                        )
                    })
                    :
                    null
            }

            {
                isGuard === false && openingsTablets.length > 0 ?
                    openingsTablets.map((el, i) => {
                        return (
                            <Fragment key={i}>
                                <CustomTabletFilter
                                    withTooltip={true}
                                    placementTooltip={'top'}
                                    textTooltip={getTenantInfoByKey('opening_name')}
                                    idTargetTooltip={`openingFilterTooltip${i}`}
                                    filterName={el.descripcion}
                                    deleteFilterFunction={() => handleDeleteOpeningTablet(el.codigo)}
                                />
                            </Fragment>
                        )
                    })
                    :
                    null
            }

            {
                contractorsTablets.length > 0 ?
                    contractorsTablets.map((el, i) => {
                        return (
                            <Fragment key={i}>
                                <CustomTabletFilter
                                    withTooltip={true}
                                    placementTooltip={'top'}
                                    textTooltip={t('CONTRACTOR')}
                                    idTargetTooltip={`contractorFilterTooltip${i}`}
                                    filterName={el.contractor_name}
                                    deleteFilterFunction={() => deleteFilter('contractors', true, el.contractor_id)}
                                />
                            </Fragment>
                        )
                    })
                    :
                    null
            }
            {isGuard === false && (
                accessBuildingTablets.map((accessBuildingTablet, idx) =>
                    <CustomTabletFilter
                        key={idx}
                        withTooltip={true}
                        placementTooltip={'top'}
                        textTooltip={getTenantInfoByKey('building_name')}
                        idTargetTooltip={`accessBuildingTablet${idx}`}
                        filterName={accessBuildingTablet.buildingDescription}
                        deleteFilterFunction={() => handleDeleteBuildingTablet(accessBuildingTablet.buildingId)}
                    />
                )
            )}

            {(isGuard && haveSelectedAnAccessOpening) && (
                <CustomTabletFilter
                    withTooltip={true}
                    placementTooltip={'top'}
                    textTooltip={getTenantInfoByKey('opening_name')}
                    idTargetTooltip={`accessOpeningTabletGuard`}
                    filterName={userOpening.descripcion}
                />
            )}

            {(isGuard && haveSelectedAnAccessBuilding) && (
                <CustomTabletFilter
                    withTooltip={true}
                    placementTooltip={'top'}
                    textTooltip={getTenantInfoByKey('building_name')}
                    idTargetTooltip={`accessBuildingTabletGuard`}
                    filterName={userBuilding.buildingDescription}
                />
            )}

            {accessAreasTablets.map((accessAreasTablet, idx) =>
                <CustomTabletFilter
                    key={idx}
                    withTooltip={true}
                    placementTooltip={'top'}
                    textTooltip={getTenantInfoByKey('area_name')}
                    idTargetTooltip={`accessAreasTablet-${idx}`}
                    filterName={accessAreasTablet.description}
                    deleteFilterFunction={() => deleteFilter('areas', true, accessAreasTablet.area_id)}
                />
            )}

            <CustomTabletFilter
                withTooltip={true}
                placementTooltip={'top'}
                textTooltip={t('PERMANENCE_TIME')}
                idTargetTooltip={`permanenceTimeFilterTooltip`}
                filterName={`${permanence_time_from} - ${permanence_time_to === null ? '+24' : permanence_time_to}`}
                /* deleteFilterFunction={() => deleteFilter('audit_status', true, el.code)} */
                deleteFilterFunction={null}
            />

        </div >
    )
}
